import SidebarCollapse from "../../../app/SidebarCollapse";
import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { setCurrentPopup, setImageState } from "../../../../store/slices/popupSlice";
import { EditableProps } from "../../editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { ImageNode } from "@common/build/types";
import RadioInput from "@builder/components/general/RadioInput";
import { useEffect, useState } from "react";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import SelectImage from "@builder/components/general/SelectImage";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useTranslation } from "react-i18next";

const EditImage: React.FC<EditableProps> = ({ parent, noRemoveImage }: EditableProps) => {
    const dispatch = useAppDispatch();
    const [imageType, setImageType] = useState<string>("static");
    const node = useAppSelector(getSelectedNode) as ImageNode;
    const { t } = useTranslation();

    const imageTypeOptions = [
        {
            value: "static",
            img: "/image-icon-thin.svg",
            checked: imageType === "static",
            disabled: !!node.dynamicData,
            tooltip: t("generalComponents.radioInput.Static")
        },
        { value: "db", img: "/db-icon.svg", checked: imageType === "db", tooltip: t("generalComponents.radioInput.Dynamic") }
    ];

    const imageTypeCallback = (value: string): void => {
        setImageType(value);
        if (value === "db") {
            dispatch(updateNodeProperty({ propertyPath: ["image"], value: "", remove: true }));
        }
    };

    const imageCallback = () => {
        dispatch(setImageState(null));
        dispatch(setCurrentPopup("images"));
    };

    const removeImageCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: ["image"], value: "", remove: true }));
    };

    useEffect(() => {
        if (node) {
            setImageType(!!node.dynamicData ? "db" : "static");
        }
    }, [node?.id]);

    return (
        <SidebarCollapse title="Image" parent={parent}>
            <RadioInput groupName="textType" options={imageTypeOptions} callback={imageTypeCallback}></RadioInput>
            {imageType === "static" ? (
                <SelectImage
                    type="image"
                    callback={imageCallback}
                    removeCallback={noRemoveImage ? undefined : removeImageCallback}
                    img={node?.image?.url}
                />
            ) : (
                <DynamicDataSelectorInput />
            )}
        </SidebarCollapse>
    );
};

export default EditImage;
